<script setup lang="ts">
import {
  ref,
} from 'vue';
import { CdrText } from '@rei/cedar';
import BadgeComponent from './OrderItemBadgeComponent.vue';
import type { IOrderImageGrid } from '../../pages/helpCenter/models/interfaces/OrderImageGrid';

const props = withDefaults(defineProps<IOrderImageGrid>(), {
  fulfillmentItems: () => ({}),
});
const maxImagesPerGrid = 3;
const fulfillmentArray = ref(props.fulfillmentItems);

(() => {
  let fulfillmentItemsTemp = [props.fulfillmentItems, props.fulfillmentItems, props.fulfillmentItems, props.fulfillmentItems];
  if (fulfillmentItemsTemp.length > maxImagesPerGrid) {
    fulfillmentItemsTemp = fulfillmentItemsTemp.slice(0, maxImagesPerGrid);
    return fulfillmentItemsTemp;
  }
  return fulfillmentItemsTemp;
})();

</script>

<template>
  <div class="image-grid">
    <BadgeComponent
      v-for="(item, index) in fulfillmentArray"
      :key="index"
      :amount="item.quantity"
    >
      <img
        class="image-grid__img"
        :src="`https://www.rei.com${item.imageUrl ? item.imageUrl : '/media/00000000-0000-0000-0000-000000000000'}`"
        :alt="item.name ? item.name : 'Order history product image'"
        data-ui="products-grid--image"
      >
    </BadgeComponent>
    <div
      v-if="props.fulfillmentItems.length > maxImagesPerGrid"
      class="order-details-secVal-it-more"
    >
      <CdrText
        tag="p"
        class="order-details-secVal-it-more-text"
      >
        {{ `+${props.fulfillmentItems.length - maxImagesPerGrid}` }}
      </CdrText>
    </div>
  </div>
</template>

<style lang="scss">
</style>
